const constants = {
    dev: {
        rightDeskUrl:"https://betarcapi.right-com.com",
        accountClientUrl:"https://accapi-v1.rightcomtech.com",
        adminApiUrl:"https://adminapi-v1.rightcomtech.com",
        cdnUrl:"https://cdn.rightcomtech.com",
        cdnToken:"Dcfb51409eb9f42f8b87e2f0248573f03D",
    },
    prod: {
        rightDeskUrl:"https://rightcareapi.rightcom.co",
        accountClientUrl:"https://accapi-v1.rightcom.co",
        adminApiUrl:"https://adminapi-v1.rightcom.co",
        cdnUrl:"https://cdn.right-com.com",
        cdnToken:"Dcfb51409eb9f42f8b87e2f0248573f03D",
    },
    intern: {
        rightDeskUrl:"https://⁠⁠api.rightdesk.tmb.cd:8443",
        accountClientUrl:"",
        adminApiUrl:"",
        cdnUrl:"https://cdn.xp.tmb.cd:8443",
        cdnToken:"Dcfb51409eb9f42f8b87e2f0248573f03D",
    },
    extern: {
        rightDeskUrl:"https://hontogbo.rightcom.com/rightcare-tmb",
        accountClientUrl:"",
        adminApiUrl:"",
        cdnUrl:"https://cdn.right-com.com",
        cdnToken:"Dcfb51409eb9f42f8b87e2f0248573f03D",
    }
}

export default constants